import { DataType, DataTypes } from "./Datatypes";

export class Attribute {

    /**
     * Returns linked entity name without attribute name.
     */
    public static GetLinkedEntityAlias(attributeAlias: string): string | null {
        const parts = attributeAlias?.split('.');
        if (parts?.length > 1) {
            return parts[0];
        }
        return null;
    }
    /**
     * Returns attribute name without the linked entity alias.
     */
    public static GetNameFromAlias(attributeAlias: string): string {
        return attributeAlias.split('.').pop()!;
    }
    /**
     * Returns an attribute data type corresponding to [PCF binding types](https://learn.microsoft.com/en-us/power-apps/developer/component-framework/manifest-schema-reference/type).
     */
    public static GetDataTypeFromMetadata(metadata: Xrm.Metadata.AttributeMetadata): DataType {
        if (!metadata) {
            return DataTypes.SingleLineText;
        }
        //@ts-ignore - missing Xrm typings
        let attributeMetadata: IAttributeMetadata = metadata;
        try {
            attributeMetadata.AttributeType;
        }
        catch (err) {
            //Power Apps fails to recognize the file type through AttributeType getter
            //seems to be the only data type to do so => we can return it
            return DataTypes.File;
        }
        switch (attributeMetadata.AttributeType) {
            case 0: {
                return DataTypes.TwoOptions;
            }
            case 1: {
                return DataTypes.LookupCustomer;
            }
            case 2: {
                switch (attributeMetadata.attributeDescriptor.Format) {
                    case "DateAndTime":
                    case "dateandtime":
                    case "datetime":
                        return DataTypes.DateAndTimeDateAndTime;
                    case "DateOnly":
                    case "date":
                        return DataTypes.DateAndTimeDateOnly;
                }
                console.warn("Unsupported data type encountered!", attributeMetadata.attributeDescriptor.Format, attributeMetadata);
                return DataTypes.DateAndTimeDateOnly;
            }
            case 3:
            case 4: {
                return DataTypes.Decimal;
            }
            case 5:
            case 18: {
                switch (attributeMetadata.attributeDescriptor.Format) {
                    case 'Duration':
                    case "1": {
                        return DataTypes.WholeDuration;
                    }
                    case "0":
                    case 'None': {
                        return DataTypes.WholeNone;
                    }
                }
                console.warn("Unsupported data type encountered!", attributeMetadata.attributeDescriptor.Format, attributeMetadata);
                return DataTypes.WholeNone;
            }
            case 6:
            case 10: {
                return DataTypes.LookupSimple;
            }
            case 7: {
                return DataTypes.Multiple;
            }
            case 8: {
                return DataTypes.Currency;
            }
            case 9: {
                return DataTypes.LookupOwner;
            }
            case 11:
            case 12:
            case 13: {
                return DataTypes.OptionSet;
            }
            case 14: {
                switch (attributeMetadata.attributeDescriptor.Format) {
                    case 'Url':
                        return DataTypes.SingleLineUrl;
                    case 'Email':
                        return DataTypes.SingleLineEmail;
                    case 'TextArea': {
                        return DataTypes.SingleLineTextArea;
                    }
                    case 'Phone': {
                        return DataTypes.SingleLinePhone;
                    }
                    case 'Text': {
                        switch (attributeMetadata.attributeDescriptor.FormatName.Value) {
                            case 'Phone': {
                                return DataTypes.SingleLinePhone;
                            }
                        }
                        return DataTypes.SingleLineText;
                    }
                }
                console.warn("Unsupported data type encountered!", attributeMetadata.attributeDescriptor.Format, attributeMetadata);
                return DataTypes.SingleLineText;

            }
            case 15: {
                return DataTypes.SingleLineText;
            }
            case 17: {
                switch (attributeMetadata.attributeDescriptor.AttributeTypeName?.Value) {
                    case 'MultiSelectPicklistType': {
                        return DataTypes.MultiSelectOptionSet;
                    }
                    case 'FileType': {
                        return DataTypes.File;
                    }
                    case 'ImageType': {
                        return DataTypes.Image;
                    }
                }
                switch (attributeMetadata.attributeDescriptor.Type) {
                    case 'multiselectpicklist': {
                        return DataTypes.MultiSelectOptionSet;
                    }
                }
                console.warn("Unsupported data type encountered!", attributeMetadata.attributeDescriptor.AttributeTypeName.Value, attributeMetadata);
                return DataTypes.SingleLineText;
            }
            case 23: {
                return DataTypes.Image;
            }
            case 16:
            case 19:
            case 20:
            default: {
                console.warn("Unsupported data type encountered!", attributeMetadata.attributeDescriptor.Format, attributeMetadata);
                return DataTypes.SingleLineText;
            }
        }
    }
}